import "jquery-mousewheel";
import "magnific-popup";



// WEBPACK FOOTER //
// ./scripts/autoload/_fancybox.js